export default __webpack_public_path__ + "static/media/food.aedcd57a.png";